import React from "react"
import { useIdleTimer } from "react-idle-timer"
import { LOGOUT_URL } from "../config/config";

function IdleTimerComponent() {
    const onIdle = () => {
        const token = sessionStorage.getItem("token");
        sessionStorage.setItem("token", "");
        sessionStorage.setItem("User role", "");
        sessionStorage.setItem("Username", "");
        sessionStorage.setItem("salesOfficeID", "");
        sessionStorage.setItem("buID", "");
        sessionStorage.setItem("divisionID", "");
        sessionStorage.setItem("branchId", "");
        window.location.assign(`${LOGOUT_URL}?token=${token}`)
    }

    useIdleTimer({
        timeout: 1000 * 60 * 15,
        onIdle: onIdle
    });

    return null;
}

export default IdleTimerComponent